import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Header from '~/components/Header';
import Footer from '~/components/Footer';

const AuthLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();
  const [message, setMessage] = useState(
    'Olá gostaria de agendar uma consulta'
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const unShowHeader = useMemo(() => {
    return (
      location.pathname.includes('links') ||
      location.pathname.includes('tv') ||
      location.pathname.includes('coi-day') ||
      location.pathname.includes('coi-prime-day') ||
      location.pathname.includes('bem-vindos')
    );
  }, [location.pathname]);

  const unShowFooter = useMemo(() => {
    return (
      location.pathname.includes('links') || location.pathname.includes('tv')
    );
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname.includes('implantes')) {
      setMessage('Olá gostaria de agendar uma avaliação para implante');
    } else {
      setMessage('Olá gostaria de agendar uma consulta');
    }
  }, [location.pathname]);

  return (
    <>
      {!unShowHeader && <Header />}
      {children}
      {!unShowFooter && <Footer message={message} />}
    </>
  );
};

export default AuthLayout;
